import React from "react";
import Button from "Components/button/Button";
import TranslatedString from "Components/TranslatedString";
import t from "Utils/translation";
import { Icon, disabledAccount } from "Icons/index";

import cx from "classnames";
import s from "./disabledAlert.scss";

export default (props) => {
  let text;
  let contactLink;
  if (props.user.type === "Customer") {
    text = <TranslatedString language={props.user.language}>account.disabled.desc.customer</TranslatedString>;
  } else if (props.user.type === "Postmaster" || props.user.type === "EmailAccount") {
    text = <TranslatedString language={props.user.language}>account.disabled.desc.postmaster</TranslatedString>;
  } else if (props.user.type === "Manager") {
    text = <TranslatedString language={props.user.language}>account.disabled.desc.manager</TranslatedString>;
  }

  if (props.user.language === "it") {
    contactLink = "http://www.qboxmail.it/contatti/";
  } else {
    contactLink = "http://www.qboxmail.com/contacts/";
  }

  return (
    <div className={s.disabledAlert}>
      <div className={s.disabledMsg}>
        <Icon svg={disabledAccount} width="10rem" height="10rem" />
        <div className={s.title}>
          <TranslatedString language={props.user.language}>
            {props.user.status_detail === "vetting" ? "account.disabled.titleVetting" : "account.disabled.title"}
          </TranslatedString>
        </div>

        <div
          className={s.info}
          dangerouslySetInnerHTML={{
            __html:
              props.user.status_detail === "vetting"
                ? t("account.disabled.desc.vetting")
                : t("account.disabled.desc.customer"),
          }}
        ></div>

        {props.user.type === "Customer" && props.user.status_detail === "vetting" && (
          <div className={s.info}>
            <TranslatedString language={props.user.language} subs={{ code: props.user.code }}>
              {props.user.status_detail === "vetting"
                ? "account.disabled.contactUsVetting"
                : "account.disabled.contactUs"}
            </TranslatedString>

            <a className={cx(s.link, "block mt-4")} href={contactLink} target="_blank">
              {contactLink}
            </a>
          </div>
        )}

        <Button className={s.btn} color="outline" onClick={() => props.logout()}>
          button.logout
        </Button>
      </div>
    </div>
  );
};
